import { IFormField } from '../IForm.types';
import { ItemForm } from './ItemForm';

export class InputSelectForm extends ItemForm {
  placeholder = 'Select a value...';
  dataSrc = 'values';
  authenticate = false;
  template = '<span>{{ item.label }}</span>';
  type = 'select';
  data: any;
  constructor(field: IFormField) {
    super(field);
    this.data = {
      values: field.admittedValues
        .split(',')
        .map((v) => v.trim())
        .map((value) => ({ value, label: value })),
    };
    }
}
